<template>
  <div class="vselect3">
    <div class="vselect3_text">{{ name }}</div>
    <el-divider direction="vertical"></el-divider>
    <div class="vselect3_text">{{ value }}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.vselect3 {
  background: #FFFFFF;
  border-radius: 20px;
  margin-right: 15px;
  box-shadow: 0px 2px 8px rgba(15, 23, 65, 0.08);
  height: 40px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .vselect3_text {
    color: #999999;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Vselect2/index.vue